import React from 'react';
import './Hashtag.css';

export function Hashtag({ text }) {
  // Teile Text in Hashtags und normalen Text
  // Sucht nach # gefolgt von beliebigen Wort-Zeichen, Umlauten und Punkten
  const parts = text.split(".");

  return (
    <>
      
              <span  className="hashtag-formatted">
                <span className="hashtag-hash">#</span>
                <span className="hashtag-word">{parts[0].replace("#", "")}</span>
                {parts.map((part, index) => (
                    index > 0 ? <span key={index} className="hashtag-hash">.{part}</span> : null
                ))}
              </span>
            
    </>
  );
}